import { FC, PropsWithChildren, createContext, useContext, useMemo, useState } from 'react';

interface ContextState {
  searchInput: string;
  searchInputLocal: string | null;
  setSearchInput: (searchInput: string) => void;
  setSearchInputLocal: (searchInput: string | null) => void;
}

const SearchContext = createContext<ContextState>({} as ContextState);

export const SearchContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [searchInput, setSearchInput] = useState('');
  const [searchInputLocal, setSearchInputLocal] = useState<string | null>('');

  const values = useMemo(
    () => ({
      searchInput,
      searchInputLocal,
      setSearchInput,
      setSearchInputLocal,
    }),
    [searchInput, searchInputLocal, setSearchInput, setSearchInputLocal],
  );

  return <SearchContext.Provider value={values}>{children}</SearchContext.Provider>;
};

export const useSearchContext = (): ContextState => useContext(SearchContext);
